import { createRouter, createWebHistory } from "vue-router";


const Dashboard = () => import( /*webpackChunkName: "Dashboard" */ "../views/Dashboard/Dashboard.vue")
const Login = () => import( /*webpackChunkName: "Login" */ "../views/Login/Login.vue")
const MemberList = () => import( /*webpackChunkName: "Member" */ "../views/Member/List.vue")
const MemberDetail = () => import( /*webpackChunkName: "MemberDetail" */ "../views/Member/Detail.vue")
const Organiztion = () => import( /*webpackChunkName: "Organiztion" */ "../views/Organiztion/Main.vue")


const Sales = () => import( /*webpackChunkName: "Sales" */ "../views/Sales/List.vue")
const Extra = () => import( /*webpackChunkName: "Extra" */ "../views/Extra/List.vue")
const Tree = () => import( /*webpackChunkName: "Tree" */ "../views/Tree/Main.vue")
const Statistics = () => import( /*webpackChunkName: "Statistics" */ "../views/Statistics/Main.vue")

const CoinMemberHistory = () => import( /*webpackChunkName: "CoinMemberHistory" */ "../views/Coin/Member.vue")
const CoinAdminHistory = () => import( /*webpackChunkName: "CoinAdminHistory" */ "../views/Coin/Admin.vue")
const CoinList = () => import( /*webpackChunkName: "CoinList" */ "../views/Coin/List.vue")
const CoinSend = () => import( /*webpackChunkName: "CoinSend" */ "../views/Coin/Send.vue")

const Profile = () => import( /*webpackChunkName: "Profile" */ "../views/Profile/Main.vue")

const AdminList = () => import( /*webpackChunkName: "Admin" */ "../views/Admin/List.vue")
const AdminDetail = () => import( /*webpackChunkName: "AdminDetail" */ "../views/Admin/Detail.vue")
const Site = () => import( /*webpackChunkName: "Site" */ "../views/Site/Main.vue")



const System = () => import( /*webpackChunkName: "System" */ "../views/System/Main.vue")



const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/member",
    name: "회원관리 / 회원목록",
    component: MemberList,
  },
  {
    path: "/member/:no",
    name: "회원관리 / 회원상세",
    component: MemberDetail,
  },
  {
    path: "/organization",
    name: "조직도",
    component: Organiztion,
  },
  {
    path: "/sales",
    name: "매출내역",
    component: Sales,
  },
  {
    path: "/extra",
    name: "수당내역",
    component: Extra,
  },
  {
    path: "/tree",
    name: "매출조직",
    component: Tree,
  },
  {
    path: "/statistics",
    name: "통계",
    component: Statistics,
  },

  {
    path: "/coin/member",
    name: "회원 전송내역",
    component: CoinMemberHistory,
  },
  {
    path: "/coin/admin",
    name: "관리자 전송내역",
    component: CoinAdminHistory,
  }, {
    path: "/coin/send",
    name: "코인 관리 / 코인 전송",
    component: CoinSend,
  }, {
    path: "/coin/list",
    name: "코인 관리 / 코인 목록",
    component: CoinList,
  },
  {
    path: "/profile",
    name: "내정보",
    component: Profile,
  },
  {
    path: "/admin",
    name: "관리자목록",
    component: AdminList,
  },
  {
    path: "/admin/:no",
    name: "관리자상세",
    component: AdminDetail,
  },
  {
    path: "/site",
    name: "사이트정보",
    component: Site,
  },
  {
    path: "/system",
    name: "시스템정보",
    component: System,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },


];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
